/**
 * @generated SignedSource<<11dcf1115fbdc0604ebd03df762db13f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesToolbar_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenu_package">;
  readonly " $fragmentType": "RoomRatesToolbar_package";
};
export type RoomRatesToolbar_package$key = {
  readonly " $data"?: RoomRatesToolbar_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesToolbar_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesToolbar_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorSettingsMenu_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "1582b7465e69175d0fb64c4016862485";

export default node;
